export default "__VITE_ASSET__Cdz6un3j__"